import { createApiCall } from 'lib/base';

const REQUEST_NEW_STOCK_ACCOUNT_ESIGN_EKYC_API_ID =
  'DASHBOARD/REQUEST_NEW_STOCK_ACCOUNT_ESIGN_EKYC_API';

const apiCall = createApiCall(
  REQUEST_NEW_STOCK_ACCOUNT_ESIGN_EKYC_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/stock-accounts/${id}/esign-ekyc/request-new`,
    method: 'POST',
    notify: true,
    isReload: true,
  })
);

export default apiCall;
